import React, { useEffect, useState } from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import { DialogActions } from "@material-ui/core";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import {
  getAssetDetail,
  saveAssetDisposal,
} from "../../../../../services/finance/finance";
import DisposalAssetFormContent from "./disposalAssetFormContent";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import store from "../../../../../store/store";
import { setObject } from "../../../../../utils/utils";
import { DateTime } from "luxon";
const disposeAssetFormSchema = yup.object().shape({
  ID: yup.number(),
  disposalType: yup.number(),
  qty: yup
    .number()
    .integer("Quantity must be integer")
    .transform((value) => (isNaN(value) ? 0 : value))
    .nullable()
    .required("Quantity is required")
    .min(1, "Quantity cannot be zero or empty")
    .default(0),
  unitPrice: yup.number().when("disposalType", {
    is: (value) => value === 2,
    then: yup
      .number()
      .transform((value) => (isNaN(value) ? 0 : value))
      .nullable()
      .required("Unit Price is required")
      .min(1, "Unit Price cannot be zero or empty")
      .default(0),
  }),
});
function DisposalAssetForm({
  assetStockID = 0,
  onConfirmSave = () => {},
  onCloseDialog,
}) {
  const { socket } = useGlobalData();
  const [asset, setAsset] = useState({
    ID: 0,
    disposalType: 2,
    vendorID: 0,
    vendorName: "",
    assetCode: "",
    assetOriginType: 1,
    assetOriginTypeName: "",
    itemID: 0,
    itemType: 0,
    itemTypeName: "",
    assetCode: "",
    itemName: "",
    qty: 0,
    assetDesc: "",
    unitPrice: 0,
    totalPrice: 0,
    qtyStock: 0,
    uomID: 0,
    uomName: "",
    currencyID: 0,
    unitValueAmount: 0,
    totalUnitDepAmount: 0,
    totalDepAmount: 0,
    totalAssetValue: 0,
    gainAssetDisposal: 0,
    cashAccountID: 0,
    cashAccountName: "",
    revAccountID: 0,
    revAccountName: "",
    exAccountID: 0,
    exAccountName: "",
    disposalDate: DateTime.now().startOf("day"),
    receivedDate: DateTime.now().startOf("day"),
    purchaseDate: DateTime.now().startOf("day"),
    depreciationStatus: 0,
    depreciationStatusDesc: "",
    disposalStatus: 0,
    disposalStatusDesc: "",
  });
  async function getAssetDetailData(assetStockID = 0) {
    const response = await getAssetDetail(assetStockID);
    const { data } = response.data;
    const { assetStock } = data;

    setAsset({
      ID: assetStock.ID,
      disposalType: 2,
      vendorID: assetStock.vendorID,
      vendorName: assetStock.vendor.vendorName,
      assetOriginType: assetStock.assetOriginType,
      assetOriginTypeName: assetStock.assetOriginTypeName,
      assetCode: assetStock.assetCode,
      itemID: assetStock.itemID,
      itemType: assetStock.itemType,
      itemTypeName: assetStock.itemTypeName,
      assetCode: assetStock.assetCode,
      itemName: assetStock.itemName,
      qty: 0,
      assetDesc: assetStock.assetDesc,
      qtyStock: assetStock.qty,
      currencyID: assetStock.currencyID,
      unitPrice: 0,
      totalPrice: 0,
      totalUnitDepAmount: assetStock.totalUnitDepAmount,
      totalDepAmount: 0,
      unitValueAmount: assetStock.unitValueAmount,
      totalAssetValue: 0,
      uomID: assetStock.uomID,
      uomName: assetStock.uom.uomName,
      receivedDate: assetStock.receivedDate,
      purchaseDate: assetStock.purchaseDate,
      depreciationStatus: assetStock.depreciationStatus,
      depreciationStatusDesc: assetStock.depreciationStatusDesc,
      disposalStatus: assetStock.disposalStatus,
      disposalStatusDesc: assetStock.disposalStatusDesc,
      gainAssetDisposal: 0,
      cashAccountID: 0,
      cashAccountName: "",
      revAccountID: 0,
      revAccountName: "",
      exAccountID: 0,
      exAccountName: "",
      disposalDate: DateTime.now().startOf("day"),
    });
  }

  useEffect(() => {
    const { auth } = store.getState();

    if (assetStockID > 0) {
      setObject(socket, "lock", assetStockID, "ASST", auth.user)
        .then((response) => {
          getAssetDetailData(assetStockID);
        })
        .catch((error) => {
          onCloseDialog();
        });
    }
    return () => {
      if (assetStockID > 0) {
        setObject(socket, "release", assetStockID, "ASST", auth.user);
      }
    };
  }, [assetStockID]);
  return (
    <AppForm
      headSubmitButton={false}
      validationSchema={disposeAssetFormSchema}
      initialValues={asset}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        values.totalUnitDepAmount = parseFloat(values.totalUnitDepAmount);
        values.totalDepAmount = parseFloat(values.totalDepAmount);
        values.unitValueAmount = parseFloat(values.unitValueAmount);
        values.totalAssetValue = parseFloat(values.totalAssetValue);
        values.gainAssetDisposal = parseFloat(values.gainAssetDisposal);
        values.unitPrice = parseFloat(values.unitPrice);
        values.totalPrice = parseFloat(values.totalPrice);
        values.qty = parseFloat(values.qty);
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Asset Disposal ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveAssetDisposal(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      <DisposalAssetFormContent />
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            onCloseDialog();
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
        <button
          type="submit"
          className="btn btn-success btn-md btn-pill btn-bold"
        >
          <i className="fas fa-save"></i>
          Save
        </button>
      </DialogActions>
    </AppForm>
  );
}

export default DisposalAssetForm;
